/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LongTermGoalDto
 */
export interface LongTermGoalDto {
    /**
     * Free-text description of the patient's long-term goal, timeline, and motivation.
     * @type {string}
     * @memberof LongTermGoalDto
     */
    text: string;
    /**
     * Unique identifier for the long-term goal
     * @type {string}
     * @memberof LongTermGoalDto
     */
    id?: string;
}

/**
 * Check if a given object implements the LongTermGoalDto interface.
 */
export function instanceOfLongTermGoalDto(value: object): value is LongTermGoalDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function LongTermGoalDtoFromJSON(json: any): LongTermGoalDto {
    return LongTermGoalDtoFromJSONTyped(json, false);
}

export function LongTermGoalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LongTermGoalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function LongTermGoalDtoToJSON(json: any): LongTermGoalDto {
    return LongTermGoalDtoToJSONTyped(json, false);
}

export function LongTermGoalDtoToJSONTyped(value?: LongTermGoalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'id': value['id'],
    };
}

